import { jsx as _jsx } from "react/jsx-runtime";
import * as react from "react";
import { LineContainerComponent } from "../../sharedComponents/lineContainerComponent.js";
import "../../assets/styles/components/propertyTab.scss";
import { FloatSliderComponent } from "../../sharedComponents/floatSliderComponent.js";
import { ConnectionPointType } from "smart-filters";
import { Vector2PropertyTabComponent } from "./properties/vector2PropertyTabComponent.js";
import { Color3PropertyTabComponent } from "./properties/color3PropertyTabComponent.js";
import { Color4PropertyTabComponent } from "./properties/color4PropertyTabComponent.js";
export class InputsPropertyTabComponent extends react.Component {
    constructor(props) {
        super(props);
    }
    processInputBlockUpdate(ib) {
        this.props.globalState.stateManager.onUpdateRequiredObservable.notifyObservers(ib);
    }
    renderInputBlock(block) {
        switch (block.type) {
            case ConnectionPointType.Color3: {
                return _jsx(Color3PropertyTabComponent, { stateManager: this.props.globalState.stateManager, inputBlock: block }, block.uniqueId);
            }
            case ConnectionPointType.Color4: {
                return _jsx(Color4PropertyTabComponent, { stateManager: this.props.globalState.stateManager, inputBlock: block }, block.uniqueId);
            }
            case ConnectionPointType.Float: {
                return (_jsx(FloatSliderComponent, { lockObject: this.props.lockObject, label: block.name, target: block.runtimeValue, propertyName: "value", min: block.editorData?.min ?? null, max: block.editorData?.max ?? null, onChange: () => this.processInputBlockUpdate(block) }, block.uniqueId));
            }
            case ConnectionPointType.Vector2: {
                return (_jsx(Vector2PropertyTabComponent, { stateManager: this.props.globalState.stateManager, lockObject: this.props.lockObject, inputBlock: block }, block.uniqueId));
            }
        }
        return null;
    }
    render() {
        return (_jsx(LineContainerComponent, { title: "INPUTS", children: this.props.inputs.map((ib) => {
                if (!ib.name) {
                    return null;
                }
                return this.renderInputBlock(ib);
            }) }));
    }
}
//# sourceMappingURL=inputsPropertyTabComponent.js.map